import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import {
  type IReference,
  ReferenceType,
} from '../../../../expressions/references/IReference.ts';
import {
  type IReferencePath,
  ReferencePathDirection,
} from '../../../../expressions/references/IReferencePath.ts';
import { WidgetType } from '../../../Widget.ts';
import { isPlainAdvancedSelectColumn } from '../advanced-select-common/IAdvancedSelectColumns.ts';
import { getUniqueOptionValue } from '../advanced-select-common/utils/geUniqueOptionValue.ts';
import { renderAdvancedSelectedOptionLabel } from '../advanced-select-common/utils/renderAdvancedSelectedOptionLabel.ts';
import { multiSelectOptionsObjectName } from '../multi-select/getMultiSelectOptionsObjectName.ts';
import { type IAdvancedMultiSelectWidget } from './IAdvancedMultiSelectWidget.ts';

/**
 * Ottiene la reference per il campo principale del widget AdvancedMultiSelect
 */
export function getAdvancedMultiSelectWidgetReference(
  path: IReferencePath,
  widget: IAdvancedMultiSelectWidget,
): IReference {
  const columnsStructure: IReference[] =
    widget.columns?.filter(isPlainAdvancedSelectColumn).map(column => ({
      type: ReferenceType.Widget,
      widgetType: null,
      path: [...path],
      id: `${widget.id}-${column.id}`,
      code: column.id,
      label: column.label,
      field: { type: column.type },
    })) ?? [];

  return {
    type: ReferenceType.Widget,
    widgetType: widget.type,
    path,
    id: widget.id,
    code: widget.code,
    label: widget.code,
    field: {
      type: Datatype.Array,
      itemsType: Datatype.Object,
      structure: columnsStructure,
    },
  };
}

/**
 * Ritorna una lista di reference per ogni opzione del widget advanced multi-select.
 */
export function getAdvancedMultiSelectWidgetOptionsReferences(
  path: IReferencePath,
  widget: IAdvancedMultiSelectWidget,
): IReference[] {
  return widget.options.map(option => {
    const optionKey = getUniqueOptionValue(widget, option);

    const optionLabel = renderAdvancedSelectedOptionLabel(
      option.values,
      widget.labelFieldColumns,
      widget.columns,
    );

    return {
      type: ReferenceType.Widget,
      widgetType: WidgetType.Boolean,
      path: [
        ...path,
        {
          direction: ReferencePathDirection.Child,
          code: multiSelectOptionsObjectName(widget.code),
        },
      ],
      id: `${widget.id}-${optionKey}`,
      code: optionKey,
      label: `${widget.code}: ${optionLabel}`,
      field: {
        type: Datatype.Boolean,
      },
    };
  });
}
